import { render, staticRenderFns } from "./PreturiServicii.vue?vue&type=template&id=5e94df94&scoped=true"
import script from "./PreturiServicii.vue?vue&type=script&lang=js"
export * from "./PreturiServicii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e94df94",
  null
  
)

export default component.exports